import fa from "element-ui/src/locale/lang/fa";

export {
  introduces
}

let introduces=[
  {
    title:'关于芯研智能',
    text: '芯研智能科技（浙江）有限公司于2023年04月03日在宁波市成立，坐落于东海之滨，这里充满活力与无限可能。我们的总部占地面积超过5000平方米，汇聚了50多名高素质员工，其中70%以上是资深的开发工程师。我们的团队专注于研发、品质和客户服务，致力于为客户提供优质的解决方案和卓越的服务。',
    img:require('@/assets/swiper/swiper1.png'),
    isLeft: true,
    isWhite: false
  },
  {
    title: '公司精神',
    text:'我们是一家专业的科技企业，专注于为客户提供全方位的解决方案。我们的主营业务包括企业资源规划（ERP）软件系统的开发与服务，以满足客户在管理与运营方面的需求。此外，我们在智能运动控制系统领域拥有丰富的经验与技术，为客户提供高效、精准的解决方案，助力其实现生产流程的智能化与优化。同时，我们致力于微波滤波器（5G）计算机调试整体解决方案的研发与实施，以满足日益增长的通信需求，助力客户在数字化时代保持竞争优势。',
    img:require('@/assets/swiper/swiper2.jpg'),
    isLeft: false,
    isWhite: true
  },
  {
    title:'公司使命',
    text:'芯研智能（浙江）有限公司的愿景是成为引领智能科技发展的领军企业，为人们的沟通与生活赋予更智能化的力量。我们的使命是不断创新，为客户提供卓越的解决方案和服务，为中国智能制造事业贡献我们的力量，为客户创造更大的价值，推动智能科技行业的发展。',
    img:require('@/assets/swiper/swiper3.jpg'),
    isLeft: true,
    isWhite: false
  }
]
